import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {FormattedMessage, FormattedHTMLMessage, intlShape, injectIntl} from 'react-intl';
import {
  trashBinRecordTypesFormat,
  trashBinRecordTypes,
} from 'helpers/constants';
import CustomerTrashBinRecord from './CustomerTrashBinRecord';
import CustomerContactTrashBinRecord from './CustomerContactTrashBinRecord';
import PoolTrashBinRecord from './PoolTrashBinRecord';
import {languages} from 'helpers/languageHelper';

class TrashBinRecord extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
    record: PropTypes.object.isRequired,
    dealer: PropTypes.object.isRequired,
    onRestore: PropTypes.func.isRequired,
  };

  render() {
    const {record, dealer} = this.props;
    const {formatMessage, locale} = this.props.intl;
    const recordTypeNames = trashBinRecordTypesFormat(formatMessage);
    const getIconClass = () => {
      switch (record.type) {
        case trashBinRecordTypes.customer:
          return 'bl bl-profile';
        case trashBinRecordTypes.customerContact:
          return 'bl bl-user';
        case trashBinRecordTypes.pool:
          return 'bl bl-pool';
        default:
          return null;
      }
    };

    return (
      <div className="panel panel-default trashbin-record">
        <div className="panel-heading">
          <i className={getIconClass()} title={recordTypeNames[record.type]}/>
          <div className="trashbin-record-info">
            <FormattedHTMLMessage id={'trashbin.record.type'} values={{type: recordTypeNames[record.type]}}/>
            <FormattedHTMLMessage id={'trashbin.record.deleted'} values={{date: moment(record.deleted).locale(languages[locale].time).format('LL')}}/>
          </div>
        </div>

        <div className="panel-body">
          {record.type === trashBinRecordTypes.customer ?
            <CustomerTrashBinRecord record={record}  dealer={dealer}/> :
          null}
          {record.type === trashBinRecordTypes.customerContact ?
            <CustomerContactTrashBinRecord record={record}  dealer={dealer}/> :
          null}
          {record.type === trashBinRecordTypes.pool ?
            <PoolTrashBinRecord record={record}  dealer={dealer}/> :
          null}
          <div className='col-sm-12 button-group'>
            <button className='btn btn-primary pull-right'
                    onClick={this.props.onRestore}><FormattedMessage id="trashbin.record.restore"/></button>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(TrashBinRecord);
